import { motion } from 'framer-motion'
import React from 'react'

type Props = {}

// Client logos from assets folder
const showcase = [
    {
        title: 'Virat Design Construction',
        images: [
            { id: 'client-1', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_56.jpg' },
            { id: 'client-2', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_57.jpg' },
            { id: 'client-3', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_58.jpg' },
            { id: 'client-4', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_59.jpg' },
            { id: 'client-5', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_60.jpg' },
            { id: 'client-6', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_61.jpg' },
            { id: 'client-7', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_62.jpg' },
            { id: 'client-8', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_63.jpg' },
            { id: 'client-9', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_64.jpg' },
            { id: 'client-10', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_65.jpg' },
            { id: 'client-11', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_66.jpg' },
            { id: 'client-12', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_67.jpg' },
            { id: 'client-13', logo: '/Virat_Design_Construction/Color_Drop_Client_Work_68.jpg' },
        ]
    },
    {
        title: 'The Ashoka Hotel',
        images: [
            { id: 'client-1', logo: '/The_Ashoka/Color_Drop_client_Work_1.jpg' },
            { id: 'client-2', logo: '/The_Ashoka/Color_Drop_client_Work_2.jpg' },
            { id: 'client-3', logo: '/The_Ashoka/Color_Drop_client_Work_3.jpg' },
            { id: 'client-4', logo: '/The_Ashoka/Color_Drop_client_Work_4.jpg' },
            { id: 'client-5', logo: '/The_Ashoka/Color_Drop_client_Work_5.jpg' },
            { id: 'client-6', logo: '/The_Ashoka/Color_Drop_client_Work_6.jpg' },
            { id: 'client-7', logo: '/The_Ashoka/Color_Drop_client_Work_7.jpg' },
            { id: 'client-17', logo: '/The_Ashoka/Color_Drop_client_Work_17.jpg' },
            { id: 'client-18', logo: '/The_Ashoka/Color_Drop_client_Work_18.jpg' },
            { id: 'client-19', logo: '/The_Ashoka/Color_Drop_client_Work_19.jpg' },
            { id: 'client-20', logo: '/The_Ashoka/Color_Drop_client_Work_20.jpg' },
        ]
    },
    {
        title: 'Dr Bhatia\'s DentoFacial',
        images: [
            { id: 'client-21', logo: '/Dr_Bhatia/Color_Drop_Client_Work_21.jpg' },
            { id: 'client-22', logo: '/Dr_Bhatia/Color_Drop_Client_Work_22.jpg' },
            { id: 'client-23', logo: '/Dr_Bhatia/Color_Drop_Client_Work_23.jpg' },
            { id: 'client-24', logo: '/Dr_Bhatia/Color_Drop_Client_Work_24.jpg' },
            { id: 'client-25', logo: '/Dr_Bhatia/Color_Drop_Client_Work_25.jpg' },
            { id: 'client-26', logo: '/Dr_Bhatia/Color_Drop_Client_Work_26.jpg' },
            { id: 'client-27', logo: '/Dr_Bhatia/Color_Drop_Client_Work_27.jpg' },
            { id: 'client-28', logo: '/Dr_Bhatia/Color_Drop_Client_Work_28.jpg' },
            { id: 'client-29', logo: '/Dr_Bhatia/Color_Drop_Client_Work_29.jpg' },
            { id: 'client-30', logo: '/Dr_Bhatia/Color_Drop_Client_Work_30.jpg' },
            { id: 'client-31', logo: '/Dr_Bhatia/Color_Drop_Client_Work_31.jpg' },
            { id: 'client-32', logo: '/Dr_Bhatia/Color_Drop_Client_Work_32.jpg' },
            { id: 'client-33', logo: '/Dr_Bhatia/Color_Drop_Client_Work_33.jpg' },
            { id: 'client-34', logo: '/Dr_Bhatia/Color_Drop_Client_Work_34.jpg' },
            { id: 'client-35', logo: '/Dr_Bhatia/Color_Drop_Client_Work_35.jpg' },
            { id: 'client-36', logo: '/Dr_Bhatia/Color_Drop_Client_Work_36.jpg' },
            { id: 'client-37', logo: '/Dr_Bhatia/Color_Drop_Client_Work_37.jpg' },
            { id: 'client-38', logo: '/Dr_Bhatia/Color_Drop_Client_Work_38.jpg' },
            { id: 'client-39', logo: '/Dr_Bhatia/Color_Drop_Client_Work_39.jpg' },
        ]
    },
    {
        title: 'Aamisha Foods Pvt Ltd',
        images: [
            { id: 'client-108', logo: '/Aamisha_Foods/Color_Drop_Client_Work_108.jpg' },
            { id: 'client-109', logo: '/Aamisha_Foods/Color_Drop_Client_Work_109.jpg' },
            { id: 'client-110', logo: '/Aamisha_Foods/Color_Drop_Client_Work_110.jpg' },
            { id: 'client-111', logo: '/Aamisha_Foods/Color_Drop_Client_Work_111.jpg' },
            { id: 'client-112', logo: '/Aamisha_Foods/Color_Drop_Client_Work_112.jpg' },
            { id: 'client-113', logo: '/Aamisha_Foods/Color_Drop_Client_Work_113.jpg' },
            { id: 'client-114', logo: '/Aamisha_Foods/Color_Drop_Client_Work_114.jpg' },
            { id: 'client-115', logo: '/Aamisha_Foods/Color_Drop_Client_Work_115.jpg' },
            { id: 'client-116', logo: '/Aamisha_Foods/Color_Drop_Client_Work_116.jpg' },
            { id: 'client-117', logo: '/Aamisha_Foods/Color_Drop_Client_Work_117.jpg' },
            { id: 'client-118', logo: '/Aamisha_Foods/Color_Drop_Client_Work_118.jpg' },
            { id: 'client-119', logo: '/Aamisha_Foods/Color_Drop_Client_Work_119.jpg' },
            { id: 'client-120', logo: '/Aamisha_Foods/Color_Drop_Client_Work_120.jpg' },
        ]
    },
    {
        title: 'Pain Relief Clinic',
        images: [
            { id: 'client-40', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_40.jpg' },
            { id: 'client-41', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_41.jpg' },
            { id: 'client-42', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_42.jpg' },
            { id: 'client-43', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_43.jpg' },
            { id: 'client-44', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_44.jpg' },
            { id: 'client-45', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_45.jpg' },
            { id: 'client-47', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_47.jpg' },
            { id: 'client-48', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_48.jpg' },
            { id: 'client-49', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_49.jpg' },
            { id: 'client-50', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_50.jpg' },
            { id: 'client-51', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_51.jpg' },
            { id: 'client-52', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_52.jpg' },
            { id: 'client-53', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_53.jpg' },
            { id: 'client-54', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_54.jpg' },
            { id: 'client-55', logo: '/Pain_Relief_Clinic/Color_Drop_Client_Work_55.jpg' },
        ]
    },
    {
        title: 'Peppa Pork',
        images: [
            { id: 'client-93', logo: '/Peppa_Pork/Color_Drop_Client_Work_93.jpg' },
            { id: 'client-94', logo: '/Peppa_Pork/Color_Drop_Client_Work_94.jpg' },
            { id: 'client-95', logo: '/Peppa_Pork/Color_Drop_Client_Work_95.jpg' },
            { id: 'client-96', logo: '/Peppa_Pork/Color_Drop_Client_Work_96.jpg' },
            { id: 'client-97', logo: '/Peppa_Pork/Color_Drop_Client_Work_97.jpg' },
            { id: 'client-98', logo: '/Peppa_Pork/Color_Drop_Client_Work_98.jpg' },
            { id: 'client-99', logo: '/Peppa_Pork/Color_Drop_Client_Work_99.jpg' },
            { id: 'client-100', logo: '/Peppa_Pork/Color_Drop_Client_Work_100.jpg' },
            { id: 'client-101', logo: '/Peppa_Pork/Color_Drop_Client_Work_101.jpg' },
            { id: 'client-102', logo: '/Peppa_Pork/Color_Drop_Client_Work_102.jpg' },
            { id: 'client-103', logo: '/Peppa_Pork/Color_Drop_Client_Work_103.jpg' },
            { id: 'client-104', logo: '/Peppa_Pork/Color_Drop_Client_Work_104.jpg' },
            { id: 'client-105', logo: '/Peppa_Pork/Color_Drop_Client_Work_105.jpg' },
            { id: 'client-106', logo: '/Peppa_Pork/Color_Drop_Client_Work_106.jpg' },
            { id: 'client-107', logo: '/Peppa_Pork/Color_Drop_Client_Work_107.jpg' },
        ]
    },
    {
        title: 'Shree Vinayakam Realities',
        images: [
            { id: 'client-84', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_84.jpg' },
            { id: 'client-85', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_85.jpg' },
            { id: 'client-86', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_86.jpg' },
            { id: 'client-87', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_87.jpg' },
            { id: 'client-88', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_88.jpg' },
            { id: 'client-89', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_89.jpg' },
            { id: 'client-90', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_90.jpg' },
            { id: 'client-91', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_91.jpg' },
            { id: 'client-92', logo: '/Vinayakam_Realties/Color_Drop_Client_Work_92.jpg' },
        ]
    },
    {
        title: 'Vivekanand Nursing Institute',
        images: [
            { id: 'client-70', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_70.jpg' },
            { id: 'client-71', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_71.jpg' },
            { id: 'client-72', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_72.jpg' },
            { id: 'client-73', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_73.jpg' },
            { id: 'client-74', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_74.jpg' },
            { id: 'client-75', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_75.jpg' },
            { id: 'client-76', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_76.jpg' },
            { id: 'client-77', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_77.jpg' },
            { id: 'client-78', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_78.jpg' },
            { id: 'client-79', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_79.jpg' },
            { id: 'client-80', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_80.jpg' },
            { id: 'client-81', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_81.jpg' },
            { id: 'client-82', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_82.jpg' },
            { id: 'client-83', logo: '/Vivekanand_Nursing/Color_Drop_Client_Work_83.jpg' },
        ]
    },
];

export const OurWork = (props: Props) => {
    return (
        <div className='pt-20 overflow-x-hidden'>
            <section className='py-24 bg-gradient-to-br from-primary-50 to-accent-50 overflow-x-hidden'>
                <div className='container-custom'>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className='text-center max-w-4xl mx-auto'
                    >
                        <h1 className='text-5xl md:text-6xl font-serif font-bold mb-6'>Our <span className='text-gradient'>Work</span></h1>
                        <p className='text-xl text-neutral-600 leading-relaxed'>
                            We are a team of experienced developers who are passionate about creating beautiful and functional websites & designs.
                        </p>
                    </motion.div>
                </div>
                {/* Showcase Section */}
                {showcase.map((project, index) =>
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: false }}
                        className="text-center overflow-x-hidden"
                    >
                        <h2 className="text-2xl md:text-3xl font-serif font-bold my-16">
                            <span className='text-gradient text-yellow-600'>CDBS</span> X <span className='text-gradient'>{project.title}</span>
                        </h2>
                        <div className="relative overflow-x-hidden w-full">
                            <div className="flex gap-8 infinite-scroll-container" style={{ width: 'max-content' }}>
                                {/* Duplicate items for seamless loop */}
                                {[...Array(2)].map((_, loopIndex) => (
                                    <React.Fragment key={loopIndex}>
                                        {project.images.map((image, imgIndex) => (
                                            <div
                                                key={`carousel-${loopIndex}-${imgIndex}`}
                                                className="flex-shrink-0 w-64 h-80 transition-all duration-300 flex items-center justify-center aspect-square cursor-pointer"
                                            >
                                                <img
                                                    src={image.logo}
                                                    alt={image.id}
                                                    className="w-full h-full object-contain transition-all duration-300 rounded-lg"
                                                    onError={(e) => {
                                                        const target = e.target as HTMLImageElement;
                                                        target.style.display = 'none';
                                                        const parent = target.parentElement;
                                                        if (parent) {
                                                            parent.innerHTML = `<div class="text-center"><div class="text-xl font-bold text-primary-600">${image.id}</div></div>`;
                                                        }
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </motion.div>)}
            </section>
        </div>
    )
}